import { render, staticRenderFns } from "./trendDetail.vue?vue&type=template&id=50a1c108&scoped=true&"
import script from "./trendDetail.vue?vue&type=script&lang=js&"
export * from "./trendDetail.vue?vue&type=script&lang=js&"
import style0 from "./trendDetail.vue?vue&type=style&index=0&id=50a1c108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1c108",
  null
  
)

export default component.exports